import { OutrightMarket, SportMatchModel } from '@nf/types/odds';
import { getHomeTeamName, getTeamName } from '@/utils/odds-utils';
import { useAtomValue } from 'jotai';
import { oddsPageAtom } from '@/atoms/odds-page';
import { matchEquals } from '@nf/utils-common/fpw/monadic';
import { CardOutrightMatch } from './card-outright-match';
import { CardSportMatch } from './card-sport-match';
import { useTranslations } from 'next-intl';
import { useMatchBetTypes } from '../../hooks/use-match-bet-types';

interface CardItemProps {
    match: SportMatchModel;
    isLeagueExpand: boolean;
	sportId: number;
}
export const CardItem = ({ match, isLeagueExpand, sportId }: CardItemProps) => {
	const oddsData = useAtomValue(oddsPageAtom);
	const t = useTranslations('General');

	const { markets, hasGetMarket } = useMatchBetTypes({
		match: match,
		isFetchFromGetMarket: isLeagueExpand,
		sportId: sportId,
		betTypeClass: 'OU'
	});

	
	return (
		<>
			{
				(isLeagueExpand || hasGetMarket) && matchEquals(sportId)
					.on(999, () => (
						<CardOutrightMatch
							match={match}
							markets={markets as OutrightMarket[]}
							teamNameMap={oddsData?.teamNameMap}
							isLoading={!hasGetMarket}
						/>
					))
					.otherwise(() => {
						const homeTeamName = getHomeTeamName(match.TeamId1, match.Neu, t('Neutral_Team'), oddsData?.teamNameMap);
						const awayTeamName = getTeamName(match.TeamId2, oddsData?.teamNameMap);
						return (
							<>
								<div className="match-brief">
									<div className="match-brief__team">{homeTeamName}</div>
									<div className="match-brief__vs">vs</div>
									<div className="match-brief__team">{awayTeamName}</div>
								</div>
								{
									(isLeagueExpand || hasGetMarket) && (
										<CardSportMatch
											match={match}
											markets={markets}
											isLoading={!hasGetMarket}
											homeTeamName={homeTeamName}
											awayTeamName={awayTeamName}
											sport={sportId}
										/>
									)
								}
							</>
						)
					})
			}
		</>
	)
}